/*
 * © 2025 Fannie Mae. All rights reserved.
 * This software contains confidential information and trade secrets of Fannie Mae.
 * Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.
 */

/**
 * AG Grid date comparator that normalises both the filter date and the cell value
 * to midnight before comparing, so epoch-ms timestamps filter correctly when the
 * user picks a date in the date picker.
 *
 * @param {Date} filterLocalDateAtMidnight - Date object from the AG Grid date filter
 * @param {number|string} cellValue - Raw cell value (epoch-ms or ISO string)
 * @returns {-1|0|1}
 */
export const dateColumnComparator = (filterLocalDateAtMidnight, cellValue) => {
  if (!cellValue) return -1;
  const c = new Date(cellValue);
  const cellMid = new Date(c.getFullYear(), c.getMonth(), c.getDate());
  const fMid = new Date(
    filterLocalDateAtMidnight.getFullYear(),
    filterLocalDateAtMidnight.getMonth(),
    filterLocalDateAtMidnight.getDate()
  );
  if (cellMid < fMid) return -1;
  if (cellMid > fMid) return 1;
  return 0;
};
